import React from "react";
import CustomerAddOrUpdateContent from "../content/customerAddOrUpdateContent";
import Layout from "../layout/Layout";

const CustomerAddOrUpdate = () => {
  return (
    <Layout>
      <CustomerAddOrUpdateContent />
    </Layout>
  );
};

export default CustomerAddOrUpdate;
